import { Theme, css } from '@emotion/react';

export const menuItemRoot = ({ colors, spacing }: Theme) => css`
  min-width: 180px;
  padding-bottom: ${spacing(2)}px;
  padding-top: ${spacing(2)}px;

  &:hover {
    background: ${colors.bgLighter};
  }

  &:focus {
    box-shadow: none;
  }
`;
